import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Select2 from "react-select";
import { STATUS } from "rsuite/esm/internals/constants";
const EditCourseSubsriber = (props) => {
  const navigate = useNavigate();
  const { id, subscriberId, pivot } = useParams();
  const [isSaving, setIsSaving] = useState(false);
  const [user, setUser] = useState("");
  const [item, setItem] = useState({
    pivot_id: "",
    status: "",
    // start_date: "",
    // expiry_date: "",
    // freeze_date: "",
    // resume_date: "",
  });

  const [errorDates, setErrorDates] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "Changes have been done successfully"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [remainingBookings, setRemainingBookings] = useState("");
  const [pivotId, setPivotId] = useState("");
  const handleChangeRemainingBookings = (newValue) => {
    setItem({ ...item, remaining_bookings: newValue });
    setRemainingBookingsError("");
  };
  const [remainingBookingsError, setRemainingBookingsError] = useState("");
  const handleChangeFreezeDate = (newValue) => {
    setItem({ ...item, freeze_date: newValue });
  };
  const handleChangeResumeDate = (newValue) => {
    setItem({ ...item, resume_date: newValue });
  };
  const handleChangeStartDate = (newValue) => {
    setItem({ ...item, start_date: newValue });
  };
  const handleChangeExpiryDate = (newValue) => {
    setItem({ ...item, expiry_date: newValue });
  };
  const handleSelectChangeStatus = (newValue) => {
    setItem({ ...item, status: newValue });
  };
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let response = "";

    try {
      response = await axios.get(`/course-booking/${pivot}`);
      setItem({
        // pivot_id:
        //   response?.data?.data?.pivot?.id !== null
        //     ? response?.data?.data?.pivot?.id
        //     : "",
        status: response?.data?.data?.status
          ? response?.data?.data?.status
          : "",
        // start_date:
        //   response?.data?.data?.pivot?.start_date !== null
        //     ? response?.data?.data?.pivot?.start_date
        //     : "",
        // expiry_date:
        //   response?.data?.data?.pivot?.expiry_date !== null
        //     ? response?.data?.data?.pivot?.expiry_date
        //     : "",
        // resume_date:
        //   response?.data?.data?.pivot?.resume_date !== null
        //     ? response?.data?.data?.pivot?.resume_date
        //     : "",
        // freeze_date:
        //   response?.data?.data?.pivot?.freeze_date !== null
        //     ? response?.data?.data?.pivot?.freeze_date
        //     : "",
      });
    } catch (error) {
      console.log(error);
    }

    setIsSaving(false);
  }
  const [error, setError] = useState("");
  return (
    <Page
      narrowWidth
      backAction={{
        onAction: () => navigate(`/admin/courses/${id}/subscribers`),
      }}
      title="Edit Subscriber"
    >
      <Card>
        <FormLayout>
          <Select
            label="Status"
            options={[
              // { label: "Pending", value: "pending" },
              { label: "Confirmed", value: "confirmed" },
              { label: "Cancelled", value: "cancelled" },
              {
                label: "Cancelled with no refund",
                value: "cancelled with no refund",
              },
            ]}
            onChange={handleSelectChangeStatus}
            value={item.status}
            placeholder="Please select"
          />
          {/* <FormLayout.Group>
            <TextField
              label="Start Date"
              value={item.start_date}
              onChange={handleChangeStartDate}
              type="date"
            />
            <TextField
              label="Expiry Date"
              value={item.expiry_date}
              onChange={handleChangeExpiryDate}
              type="date"
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <TextField
              label="Freeze Date"
              value={item.freeze_date}
              onChange={handleChangeFreezeDate}
              type="date"
            />
            <TextField
              label="Resume Date"
              value={item.resume_date}
              onChange={handleChangeResumeDate}
              type="date"
            />
          </FormLayout.Group>
          <InlineError message={errorDates} /> */}
          <InlineError message={error} />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );

  function handleSave() {
    // if (
    //   item.resume_date &&
    //   !item.freeze_date
    //   // (!item.resume_date && item.freeze_date)
    // ) {
    //   setErrorDates("Please fill the freeze date");
    // } else {
    setIsSaving(true);
    axios
      .patch(`/course-booking/${pivot}`, {
        status: item.status,
        // start_date: item.start_date,
        // expiry_date: item.expiry_date,
        // ...(item.resume_date && { resume_date: item.resume_date }),
        // ...(item.freeze_date && { freeze_date: item.freeze_date }),
      })
      .then((result) => {
        setIsSaving(false);
        toggleActive();
      })
      .catch(function (error) {
        setError(error.response.data.message);
        setIsSaving(false);
      });
    //}
  }
};

export default EditCourseSubsriber;
